/**
 * Normaliza uma string removendo acentos e transformando em minúsculas
 * @param str - String a ser normalizada
 * @returns String normalizada
 */
export const normalizeString = (str: string | null | undefined): string => {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

/**
 * Formata um valor numérico para o padrão de moeda brasileira (R$ 0,00)
 * @param valor - Valor a ser formatado
 * @returns String formatada em BRL
 */
export const formatarMoeda = (valor: number | string | null | undefined): string => {
  const num = typeof valor === 'number' ? valor : parseFloat(String(valor || 0));
  if (isNaN(num)) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(num);
};
